<template>
  <el-form
    v-if="isForm"
    label-position="top"
    :model="formData"
    ref="formData"
    >
    <el-card
      class="box-card trans-card"
      >
      <form-title
        :base="base"
        :isEdit="true"
        :hasTrans="true"
        :showTrans="showTrans"
        :setTrans="setTrans"
        :path="basePath"
        slot="header"
        >
      </form-title>
      <base-field
        :base="base"
        :formData="formData"
        :idField="dataIdField"
        >
      </base-field>
      <el-row :gutter="10">
        <el-col :sm="24" :md="12">
          <el-card class="box-card">
            <div slot="header">
              <el-row :gutter="10">
                <el-col :sm="24" :md="12">
                  {{ $t('api.defaultText') }}
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :sm="12"
                  >
                  <convert-chinese
                    v-if="langObj[langId] && langObj[langId].code.startsWith('zh')"
                    type="checkbox"
                    :lang="langObj[langId]"
                    ref="convert"
                    >
                  </convert-chinese>
                </el-col>
                <el-col
                  :sm="12"
                  >
                  <el-button
                    class="trans-copy"
                    icon="el-icon-copy-document"
                    @click="copyTrans"
                    >
                    {{ $t('api.trans.copyText') }}
                    <i class="el-icon-d-arrow-right"></i>
                  </el-button>
                </el-col>
              </el-row>
            </div>
            <slot fields
              :data="formData"
              :disabled="true"
              :isDef="true"
              :copy="copyTransField"
              >
            </slot>
          </el-card>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form
            label-position="top"
            :model="transData"
            ref="transData"
            >
            <el-card class="box-card">
              <div slot="header">
                <el-row :gutter="10">
                  <el-col :sm="24" :md="12">
                    {{ $t('api.transText') }}
                  </el-col>
                  <el-col :sm="24" :md="12" class="right">
                    <el-select
                      v-model="langId"
                      class="form-item"
                      filterable
                      size="mini"
                      :loading="langLoading"
                      :default-first-option="true"
                      @change="changeLang"
                      >
                      <el-option
                        v-for="item in langList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col
                    :sm="12"
                    >
                    <el-checkbox
                      v-model="transData.status"
                      :true-label="1"
                      :false-label="0"
                      @change="handleCheckTransAllChange"
                      >
                      {{ $t('api.trans.checked') }}
                    </el-checkbox>
                  </el-col>
                  <el-col
                    :sm="12"
                    >
                    <convert-chinese
                      v-if="langObj[langId] && langObj[langId].code.startsWith('zh')"
                      type="button"
                      :lang="langObj[langId]"
                      :getLangTrans="getLangTrans"
                      >
                    </convert-chinese>
                  </el-col>
                </el-row>
              </div>
              <slot fields
                :data="transData"
                :disabled="false"
                :isDef="false"
                :handleCheckChange="handleCheckTransChange"
                >
              </slot>
            </el-card>
            <el-row :gutter="10">
              <el-col class="right">
                <el-button
                  type="primary"
                  native-type="submit"
                  @click.native.prevent="submitForm"
                  :loading="submitLoading"
                  :disabled="langId === ''"
                  >
                  {{ $t('api.saveBtn') }}
                </el-button>
                <el-button
                  type="warning"
                  :disabled="transId === 0"
                  @click="clear">
                  {{ $t('api.clearBtn') }}
                </el-button>
                <el-button
                  @click="setTrans(false)">
                  {{ $t('api.cancelBtn') }}
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </el-form>
  <el-table-column
    v-else
    v-bind="$attrs"
    :label="getTransText('translation')"
    column-key="trans_status"
    :filters="langCheckFilter"
    align="center"
    >
    <template slot-scope="scope">
      <el-tag
        v-for="trans in scope.row.trans"
        v-if="trans[nameField] !== '' || trans.trans_status === 1"
        class="tag-list"
        :key="trans.id"
        size="small"
        effect="plain"
        :type="trans.trans_status === 1 ? 'primary' : 'danger'"
        >
        <flag-item
          :code="trans.lang_code">
        </flag-item>
        <span
          v-if="trans[nameField] === ''"
          class="default-trans"
          >
          [{{ $t('api.defaultText') }}]
        </span>
        <el-tooltip
          v-else
          class="item"
          effect="dark"
          placement="top-end"
          >
          <div
            slot="content"
            class="tool-tip-content"
            >
            {{ trans[nameField] }}
          </div>
          <span>{{ trans[nameField] }}</span>
        </el-tooltip>
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>

import _ from 'lodash'
import { getTransText, getStatusField } from '@/utils/i18n'
import { fetchList as fetchLangList } from '@/api/setting/language'
import {
  fetchList,
  fetchOne,
  create,
  updateOne,
  deleteOne
  // updateStatus
} from '@/api/trans'
import Fetch from '@/mixins/fetch'

export default {
  components: {
    ConvertChinese: () => import('@/components/ConvertChinese')
  },
  name: 'trans-field',
  mixins: [Fetch],
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    idField: {
      type: String,
      default: ''
    },
    dataIdField: {
      type: String,
      default: 'id'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    code: {
      type: String,
      default: ''
    },
    formValid: {
      type: Function,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    defData: {
      type: Object,
      default: () => {
        return {
          status: 0
        }
      }
    },
    showTrans: {
      type: Boolean,
      default: false
    },
    setTrans: {
      type: Function,
      default: () => {}
    },
    updateTransData: {
      type: Function,
      default: (data) => { return data }
    },
    isForm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      basePath: this.path || this.base,
      langId: '',
      transId: 0,
      transData: {},
      langList: [],
      langObj: {},
      langFilter: [],
      langLoading: false,
      statusRegex: /.+?_status$/,
      submitLoading: false
    }
  },
  created () {
  },
  mounted () {
    this.$store.dispatch('InitLanguage', this).then(() => {
      if (this.isForm) {
        this.updateTrans()
        this.$ebus.$on('renewLang', this.updateTrans)
      } else {
        this.resetLangFilter()
        this.$ebus.$on('renewLang', this.resetLangFilter)
      }
    })
  },
  beforeDestroy () {
    if (this.isForm) {
      this.$ebus.$off('renewLang', this.updateTrans)
    } else {
      this.$ebus.$off('renewLang', this.resetLangFilter)
    }
  },
  computed: {
    langCheckFilter () {
      let f = []
      for (let id in this.langFilter) {
        f.push(
          this.getLangFilter(this.langFilter[id], 'unchecked', 0),
          this.getLangFilter(this.langFilter[id], 'checked', 1)
        )
      }
      return f
    }
  },
  methods: {
    getStatusField,
    getTransText,
    fetchLangList,
    fetchList,
    fetchOne,
    create,
    updateOne,
    deleteOne,
    resetLangFilter () {
      this.langFilter = this.$store.getters.languageFilter
    },
    getLangFilter (data, key, status) {
      let d = Object.assign({}, data)
      d.text += ' ' + this.$t('api.trans.status.' + key)
      d.value = d.value + '-' + status
      return d
    },
    updateTrans () {
      this.langLoading = true
      this.fetchList(this.basePath, {
        filter: '{' + this.idField + ':' + this.formData[this.dataIdField] + '}',
        sort: 'id'
      }).then(res => {
        let d = res.data
        let langId = null
        this.langObj = {}
        for (let i = 0; i < d.length; ++i) {
          let t = d[i]
          this.langObj[t.id] = t
          if (langId === null && t.trans_id > 0) {
            langId = t.id
          }
        }
        let list = []
        let langs = this.$store.getters.languageList
        for (let idx in langs) {
          let t = langs[idx]
          let obj = this.langObj[t.id]
          if (obj !== undefined) {
            obj.name = t.name
            list.push(obj)
          } else {
            this.langObj[t.id] = Object.assign({}, t)
            list.push({
              id: t.id,
              code: t.code,
              name: t.name,
              product_id: this.formData[this.dataIdField]
            })
          }
        }
        this.langList = list
        if (this.$store.getters.translang !== undefined) {
          langId = parseInt(this.$store.getters.translang)
        }
        this.langId = langId || 0
        this.getTransByLang(this.langId)
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.langLoading = false
      })
    },
    setTransData (id, data) {
      this.$refs.transData.resetFields()
      this.transId = id
      this.transData = _.cloneDeep(data)
    },
    getTransByLang (id) {
      let langId = id || 0
      if (this.langObj[langId] && this.langObj[langId].trans_id > 0) {
        this.getTrans(this.langObj[langId].trans_id)
      } else {
        this.setTransData(0, this.defData)
      }
    },
    getTrans (id) {
      this.fetchOne(this.basePath, id).then(response => {
        this.setTransData(id, this.updateTransData(response.data))
      }).catch(error => {
        console.log(error)
      }).then(() => {
      })
    },
    saveDone () {
      this.$message({
        message: this.$t('api.transSaveDoneMsg', {
          langName: this.langObj[this.langId].name
        }),
        type: 'success',
        duration: 2000
      })
      this.setTrans(false, true)
    },
    submitForm () {
      this.$refs.transData.validate((valid, invalidFields) => {
        if (!valid) {
          this.$_alert(invalidFields)
          return false
        }
        this.submitLoading = true
        let data = _.cloneDeep(this.transData)
        let uncheckedCount = 0
        this.$refs.transData.fields.forEach((f) => {
          if (f.prop === undefined) {
            return
          }
          let d = data[f.prop]
          if (d !== undefined) {
            if (Array.isArray(d)) {
              d.forEach((obj) => {
                for (let prop in obj) {
                  if (typeof obj[prop] === 'string') {
                    let sf = this.getStatusField(prop)
                    if (obj[sf] === 0 || obj[sf] === undefined) {
                      uncheckedCount++
                    }
                  }
                }
              })
            } else {
              let sf = this.getStatusField(f.prop)
              if (data[sf] === 0 || data[sf] === undefined) {
                uncheckedCount++
              }
            }
          }
        })
        data.status = (uncheckedCount === 0) ? 1 : 0

        if (this.transId === 0) {
          data.lang_id = this.langId
          data[this.idField] = this.formData[this.dataIdField]
          this.create(this.basePath, data).then(response => {
            this.saveDone()
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.submitLoading = false
          })
        } else {
          this.updateOne(this.basePath, this.transId, data).then(response => {
            this.saveDone()
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.submitLoading = false
          })
        }
      })
    },
    clear () {
      var msg = this.$t('api.clearTransConfirmMsg', {
        langName: this.langObj[this.langId].name
      })
      var title = this.$t('api.clearTransConfirmTitle')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.clearLoading = true
        this.deleteOne(this.basePath, this.transId).then(response => {
          this.updateTrans()
          this.$refs.transData.resetFields()
          this.transData = _.cloneDeep(this.defData)
          this.transId = 0
          this.$message({
            message: this.$t('api.clearTransMsg'),
            type: 'success',
            duration: 2000
          })
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.clearLoading = false
        })
      }).catch(() => {
      })
    },
    changeLang (id) {
      this.getTransByLang(id)
      this.$store.dispatch('setTransLang', id)
    },
    copyTrans () {
      this.$refs.transData.fields.forEach((f) => {
        this.copyTransField(f.prop)
      })
      this.$set(this.transData, 'status', 1)
    },
    copyTransField (fName, subName, idx) {
      let name = subName || fName
      this.copyTransData(this.formData, name, fName, idx)
    },
    copyTransData (data, name, fName, idx) {
      if (data[name] !== undefined) {
        if (Array.isArray(data[name])) {
          if (idx !== undefined) {
            this.setField(data[name][idx][fName], this.transData[name][idx], fName)
          } else {
            data[name].forEach((obj, idx) => {
              let trans = this.transData[name][idx]
              for (let prop in obj) {
                if (trans[prop] !== undefined) {
                  this.setField(obj[prop], trans, prop)
                }
              }
            })
          }
        } else {
          this.setField(data[name], this.transData, name)
        }
        this.handleCheckTransChange()
      }
    },
    setField (text, obj, fname) {
      if (this.$refs.convert && this.$refs.convert.isNeedCC) {
        this.$refs.convert.doConvert(text, obj, fname)
      } else {
        this.$set(obj, fname, text)
        this.$set(obj, this.getStatusField(fname), 1)
      }
    },
    getLangTrans () {
      if (this.$refs.convert) {
        this.$refs.convert.isNeedCC = true
        let langId = (this.langId === 0) ? 2 : 0
        if (this.langObj[langId] && this.langObj[langId].trans_id) {
          let id = this.langObj[langId].trans_id
          this.fetchOne(this.basePath, id).then(res => {
            let data = this.updateTransData(res.data)
            this.$refs.transData.fields.forEach((f) => {
              this.copyTransData(data, f.prop, f.prop)
            })
            this.$set(this.transData, 'status', 1)
          }).catch(error => {
            console.log(error)
          })
        }
      }
    },
    handleCheckTransAllChange (val) {
      this.$refs.transData.fields.forEach((f) => {
        if (f.prop === undefined ||
          this.formData[f.prop] === undefined) {
          return
        }
        let d = this.transData[f.prop]
        if (Array.isArray(d)) {
          d.forEach((obj) => {
            for (let prop in obj) {
              if (typeof obj[prop] === 'string') {
                this.$set(obj, this.getStatusField(prop), val)
              }
            }
          })
        } else {
          this.$set(this.transData, this.getStatusField(f.prop), val)
        }
      })
    },
    handleCheckTransChange () {
      let uncheckedCount = 0
      this.$refs.transData.fields.forEach((f) => {
        if (f.prop === undefined ||
          this.formData[f.prop] === undefined) {
          return
        }
        let d = this.transData[f.prop]
        if (Array.isArray(d)) {
          d.forEach((obj) => {
            for (let prop in obj) {
              if (typeof obj[prop] === 'string' &&
                obj[this.getStatusField(prop)] !== 1) {
                uncheckedCount++
              }
            }
          })
        } else {
          if (this.transData[this.getStatusField(f.prop)] !== 1) {
            uncheckedCount++
          }
        }
      })
      this.$set(this.transData, 'status', (uncheckedCount === 0) ? 1 : 0)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .default-trans {
    font-weight: 800;
    opacity: 0.5;
  }
</style>
